import { Grid } from '@mui/material'
import KpiCard from './KpiCard'

const ExecutiveOverview = ({ data, onKpiClick }) => {
  if (!data) return null
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Today's Sales"
          value={data.todaySales?.value}
          trend={data.todaySales?.changePct}
          sublabel={data.todaySales?.label}
          accent="red"
          currency
          onClick={() => onKpiClick('todaySales')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Monthly Sales"
          value={data.monthlySales?.value}
          trend={data.monthlySales?.changePct}
          sublabel={data.monthlySales?.label}
          accent="green"
          currency
          onClick={() => onKpiClick('monthlySales')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Active Partner Shops"
          value={data.activePartnerShops?.value}
          sublabel={data.activePartnerShops?.sublabel}
          accent="amber"
          onClick={() => onKpiClick('activePartners')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Pending Orders"
          value={data.pendingOrders?.value}
          sublabel={data.pendingOrders?.sublabel}
          accent="red"
          alert
          onClick={() => onKpiClick('pendingOrders')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Awaiting Verification"
          value={data.awaitingVerificationOrders?.value}
          sublabel={data.awaitingVerificationOrders?.sublabel}
          accent="amber"
          warn={(data.awaitingVerificationOrders?.value || 0) > 0}
          onClick={() => onKpiClick('awaitingVerificationOrders')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Rejected Payment Proofs"
          value={data.rejectedPaymentProofs?.value}
          sublabel={data.rejectedPaymentProofs?.sublabel}
          accent="red"
          alert={(data.rejectedPaymentProofs?.value || 0) > 0}
          onClick={() => onKpiClick('rejectedPaymentProofs')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Expiring ≤ 30 Days"
          value={data.expiringItems?.value}
          sublabel={data.expiringItems?.sublabel}
          accent="amber"
          warn={data.expiringItems?.value > 0}
          onClick={() => onKpiClick('expiringItems')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Low Stock Items"
          value={data.lowStockItems?.value}
          sublabel={data.lowStockItems?.sublabel}
          accent="red"
          alert={data.lowStockItems?.criticalCount > 0}
          onClick={() => onKpiClick('lowStock')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <KpiCard
          title="Undelivered Quantity"
          value={data.undeliveredQuantity?.value}
          sublabel={data.undeliveredQuantity?.sublabel}
          accent="amber"
          warn={(data.undeliveredQuantity?.value || 0) > 0}
          onClick={() => onKpiClick('undeliveredQuantity')}
        />
      </Grid>
    </Grid>
  )
}

export default ExecutiveOverview
